<div fxLayout='column' fxFill [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <!-- Header -->
  <mat-progress-bar
    [class.hidden]='cService.hideIndeterminateProgress'
    mode='indeterminate'
    class='fixed extreme-tl'
    color='accent'
  ></mat-progress-bar>

  <div
    fxLayout='column'
    [style.background-color]="'#' + cService.userProfile.HqColour"
    style='color: white; padding: 0 15px'
  >
    <div fxLayout='row' fxLayoutAlign='space-between' style='height: 45px; margin-top: 10px; opacity: 0.8'>
      <div mat-dialog-title class='margin-none force' fxLayout='row' fxFlex *ngIf='imageData && imageData.length'>
        <div>
          <mat-icon style='position: relative; top: 4px'>image</mat-icon>
          &nbsp;
          <span *ngIf='isCrashImages; else showOtherTitle'>{{ 'GENERIC.crashPhotos' | translate }}</span>
          <ng-template #showOtherTitle>
            <span *ngIf='isNonUkLicenceDocs'>{{ 'GENERIC.nonUkLicenceUploads' | translate }}</span>
            <span *ngIf='isExternalTrainingDocs'
            >{{ selectedImage.firstName }} {{ selectedImage.lastName }}
              {{ 'GENERIC.externalTrainingDocument' | translate }}</span
            >
            <span *ngIf='isDerDocuments'>{{ 'GENERIC.documents' | translate }}</span>
            <span *ngIf='!canPostData && !isExternalTrainingDocs && !isDerDocuments'>{{
              'GENERIC.images' | translate
              }}</span>
          </ng-template>

          <small style='opacity: 0.5'>&nbsp; {{ currentIndex + 1 }} of {{ maxIndex + 1 }}</small>
        </div>

        <span fxFlex></span>

        <a
          mat-icon-button
          [href]='selectedImage.imageStream | trustAsSafeUrl'
          target='_blank'
          [disabled]='selectedImage.imageStream ? false : true'
          [download]='selectedImage.generatedFileName'
        >
          <mat-icon class='utility-icons'>download</mat-icon>
        </a>
      </div>

      <span *ngIf='!imageData || !imageData.length' fxFlex></span>
      <button
        mat-icon-button
        mat-dialog-close
        style='top: -10px; right: -15px'
        [style.backgroundColor]="'#' + cService.userProfile.HqColour"
        class='close-button'
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div [fxLayout]="cService.isPcViewport ? 'row' : 'column'" class='filter-body' *ngIf='selectedImage' fxFlex>
    <!-- Image viewer -->
    <div *ngIf='imageData && imageData.length' fxFlex class='image-viewer' fxLayout='column'>
      <!-- Viewer Navigation -->
      <div
        class='image-nav'
        *ngIf='currentIndex !== minIndex'
        [class.image-nav-mobile]='!cService.isPcViewport'
        fxLayout='column'
        (click)='navigateImage()'
      >
        <span fxFlex='40'></span>
        <div class='image-nav-round-bg'>
          <mat-icon [style.color]="'#' + cService.userProfile?.HqColour">navigate_before</mat-icon>
        </div>
        <span fxFlex></span>
      </div>

      <div
        class='image-nav nav-right'
        *ngIf='currentIndex !== maxIndex'
        [class.image-nav-mobile]='!cService.isPcViewport'
        fxLayout='column'
        (click)='navigateImage(true)'
      >
        <span fxFlex='40'></span>
        <div class='image-nav-round-bg'>
          <mat-icon [style.color]="'#' + cService.userProfile?.HqColour">navigate_next</mat-icon>
        </div>
        <span fxFlex></span>
      </div>

      <!-- Image -->
      <div fxLayout='row' fxLayoutAlign='center' fxFlex style="justify-content: center;">
        <img
          data-ot-ignore
          class='image optanon-category'
          [src]='selectedImage.imageStream'
          *ngIf='selectedImage.imageStream && selectedImage.mediaType === mediaTypes.image'
        />

        <pdf-viewer
          fxFlex
          [autoresize]='true'
          [stick-to-page]='true'
          [render-text]='true'
          [external-link-target]="'blank'"
          [fit-to-page]='true'
          [original-size]='false'
          [show-all]='true'
          [src]='selectedImage.imageStream'
          *ngIf='selectedImage.imageStream && selectedImage.mediaType === mediaTypes.document'
        >
        </pdf-viewer>

        <audio
          controls
          [src]='selectedImage.imageStream | trustAsSafeUrl'
          *ngIf='selectedImage.imageStream && selectedImage.mediaType === mediaTypes.audio'
        ></audio>

        <div
          style='padding: 0 100px; width: 100%'
          *ngIf='selectedImage.imageStream && selectedImage.mediaType === mediaTypes.video'
        >
          <video style='width: 100%' controls [src]='selectedImage.imageStream | trustAsSafeUrl'></video>
        </div>
      </div>
    </div>

    <div
      *ngIf='imageData && imageData.length'
      [fxFlex]="cService.isPcViewport ? '35' : ''"
      fxLayout='column'
      class='image-details-pane'
    >
      <!-- Title -->
      <div class='details-header'>{{ 'GENERIC.details' | translate | uppercase }}</div>

      <!-- Driver Information -->
      <div class='driver-details' *ngIf='selectedImage.firstName || selectedImage.lastName || selectedImage.date'>
        <div class='padding-b-15' *ngIf='selectedImage.firstName || selectedImage.lastName'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.driver' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.firstName + ' ' + selectedImage.lastName }}</small>
            <small *ngIf='selectedImage.pin'> - {{ selectedImage.pin }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.title'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.title' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.title }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.reason'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.reason' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.reason }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.eventType'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.eventType' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.eventType }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.eventDate'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.eventDate' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.eventDate | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.dateAssigned'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.dateAssigned' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.dateAssigned | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.dateCompleted'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.dateCompleted' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.dateCompleted | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.rating'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTCOLUMNS.Rating' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.rating }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.organisation'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.organisation' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.organisation }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.documentTitle'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.documentTitle' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.documentTitle }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.uploadedDate'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.uploaded' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.uploadedDate | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf="selectedImage.approvedDate && selectedImage.approved === 'yes'">
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.approved' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedImage.approvedDate | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf="selectedImage.approvedDate && selectedImage.approved === 'no'">
          <div class='bold padding-b-5'>
            <small style='color: red'>{{ 'GENERIC.notApproved' | translate | uppercase }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedImage.approvedDate && selectedImage.approved === null'>
          <div class='bold padding-b-5'>
            <small style='color: red'>{{ 'GENERIC.awaitingApproval' | translate | uppercase }}</small>
          </div>
        </div>

        <div *ngIf='selectedImage.date'>
          <div class='bold padding-b-5'>
            <small *ngIf='canPostData; else otherTitle'>{{ 'GENERIC.date' | translate | uppercase }}</small>
            <ng-template #otherTitle>
              <small>{{ 'GENERIC.preTripFiled' | translate | uppercase }}</small>
            </ng-template>
          </div>
          <div>
            <small>{{ selectedImage.date | date: 'yyyy-MM-dd' }}</small>
            <small *ngIf='selectedImage.time'>{{ selectedImage.time }}</small>
          </div>
        </div>
      </div>

      <!-- Image details -->
      <div class='image-details' fxFlex *ngIf='!canPostData'>
        <div *ngIf='selectedImage.detailTitle || selectedImage.details'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.damage' | translate | uppercase }}</small>
          </div>
          <div>
            <div class='padding-b-5'>{{ selectedImage.detailTitle }}</div>
            <small>{{ selectedImage.details }}</small>
          </div>
        </div>

        <div *ngIf="selectedImage.hasOwnProperty('isApproved')">
          <div class='padding-b-5'>
            <div fxFlex fxLayoutAlign='start center' *ngIf='selectedImage.isApproved'>
              <mat-icon vrm-color>check_circle</mat-icon>
              <span class='padding-l-5'>{{ 'GENERIC.uploadApproved' | translate }}</span>
            </div>
            <span fxFlex fxLayoutAlign='start center' *ngIf='!selectedImage.isApproved'>
							<mat-icon vrm-color>error</mat-icon>
							<span class='padding-l-5'>{{ 'GENERIC.uploadNotApproved' | translate }}</span>
						</span>
          </div>
        </div>
      </div>

      <!-- Image/ document approval form -->
      <div class='image-details' fxFlex *ngIf='canPostData'>
        <div class='bold padding-b-10' fxLayout='row'>
          <span>{{ 'REPORTDATA.status' | translate | uppercase }}</span> &nbsp;
          <small
            *ngIf="
							!licenceApprovalForm.controls['approved'].disabled &&
							licenceApprovalForm.controls['approved'].invalid
						"
          >
            <mat-error>{{ 'FORM.required' | translate }}</mat-error>
          </small>
        </div>
        <div>
          <form [formGroup]='licenceApprovalForm' (submit)='approveOrDisapproveLicence()'>
            <div fxLayout='column'>
              <mat-radio-group formControlName='approved' color='primary'>
                <mat-radio-button value='yes' class='margin-r-20'>{{
                  'GENERIC.approved' | translate
                  }}</mat-radio-button>
                <mat-radio-button value='no'>{{ 'GENERIC.notApproved' | translate }}</mat-radio-button>
              </mat-radio-group>

              <mat-form-field class='example-full-width' appearance='fill' class='margin-t-40'>
                <mat-label>{{ 'GENERIC.comment' | translate }}</mat-label>
                <textarea matInput rows='5' formControlName='approved_description'></textarea>
                <mat-error
                  *ngIf="
										!licenceApprovalForm.controls['approved_description'].valid &&
										licenceApprovalForm.controls['approved_description'].touched
									"
                >
                  {{ 'FORM.required' | translate }}
                </mat-error>
              </mat-form-field>

              <div fxFlex fxLayoutAlign='center'>
                <button
                  type='submit'
                  mat-raised-button
                  vrm-raised-button
                  color='primary'
                  [disabled]='
										!licenceApprovalForm.valid ||
										!cService.hideIndeterminateProgress ||
										selectedImage.approved !== null
									'
                  style='min-width: 100px; line-height: 43px'
                >
                  {{ 'FORM.submit' | translate }}
                </button>
              </div>
              <div
                class='margin-t-20 text-align-c bold'
                *ngIf='selectedImage.formInfo'
                [class.green-text]="selectedImage.formInfo.type === 'success'"
                [class.red-text]="selectedImage.formInfo.type === 'error'"
                [class.amber-text]="selectedImage.formInfo.type === 'warning'"
              >
                {{ formInfo.message }}
              </div>
              <div *ngIf='formChangedMessage' class='amber-text margin-t-10 text-align-c bold'>
                {{ formChangedMessage }}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
